<template>
  <layout name="Error" title="500">
    <div>
      <p class="error-description">
        Whoops! We're down right now. <br />
        Hold tight, we'll return soon.
      </p>
      <VHr type="dark"></VHr>
      <p class="error-additional-text">
        If this problem persists for a long time -
        <v-link
          size="sm"
          type="dark"
          href="mailto:support@inkit.io"
          label="shoot us an email"
          inverted
        />.
      </p>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import VLink from "@/components/VLink";
import VHr from "@/components/VHr";

export default Vue.component("ServerError", {
  components: {
    Layout,
    VLink,
    VHr
  }
});
</script>

<style lang="scss" scoped></style>
